/**
 * If you are not familiar with React Navigation, refer to the "Fundamentals" guide:
 * https://reactnavigation.org/docs/getting-started
 *
 */
import { createMaterialTopTabNavigator } from "@react-navigation/material-top-tabs";
import HomeTabNavigator from "./HomeTabNavigator";
import ModalScreen from "../../../screens/ModalScreen";
import Colors from "../../../utils/constants/colors";
import useColorScheme from "../../../hooks/useColorScheme";
import { RootTabParamList, RootTabScreenProps } from "../../../types";
import UserSettingsTabNavigator from "../../SharedNavigator/TabNavigator/UserSettingsTabNavigator";
import { StyleSheet } from "react-native";
import { useTranslation } from "../../../utils/useTranslation";
import { useSelector } from "react-redux";
import { useAppTheme } from "../../../hooks/useAppTheme";


const Tab = createMaterialTopTabNavigator<RootTabParamList>();

export default function TopTabNavigator({}) {
  const colorScheme = useColorScheme();
  const { colors } = useAppTheme();
  const Tab = createMaterialTopTabNavigator<RootTabParamList>();
  const { t } = useTranslation();
  const { userInfo } = useSelector((state: any) => state.configurations);

  return (
    <Tab.Navigator
      initialRouteName="Home"
      screenOptions={{
        swipeEnabled: false,
        tabBarActiveTintColor: Colors[colorScheme].tint,
        tabBarIndicatorStyle: styles._tabBarIndicatorStyle,
        tabBarStyle: [
          {
            backgroundColor: colors.surface,
            borderTopColor: colors.border,
          },
          styles._tabBarStyle,
        ],
        tabBarLabelStyle: styles._tabBarLabelStyle,
        tabBarItemStyle: styles._tabBarItemStyle,
      }}
    >
      <Tab.Screen
        name="Home"
        component={HomeTabNavigator}
        options={({}: RootTabScreenProps<"Home">) => ({
          title: t("home"),
          tabBarItemStyle: { display: "none" },
        })}
      />
      <Tab.Screen
        name="Help"
        component={ModalScreen}
        options={{
          title: t("help"),
          tabBarItemStyle: { display: "none" },
        }}
        listeners={{
          tabPress: (e) => {
            e.preventDefault();
          },
        }}
      />
      <Tab.Screen
        name="UserSettings"
        component={UserSettingsTabNavigator}
        options={({}: RootTabScreenProps<"UserSettings">) => ({
          title: t("accounts"),
          tabBarItemStyle: { display: "none" },
        })}
        listeners={{
          tabPress: (e) => {
            // Prevent default action
          },
        }}
      />
    </Tab.Navigator>
  );
}

const styles = StyleSheet.create({
  _tabBarIndicatorStyle: {
    backgroundColor: "transparent", // Make indicator transparent
    height: 0, // Remove indicator height
  },
  _tabBarStyle: {
    height: 60,
    width: 0,
    marginRight: "5%",
    alignSelf: "flex-end",
    // justifySelf: "center",
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
  _tabBarLabelStyle: {
    fontSize: 16,
    textTransform: "none",
  },
  _tabBarItemStyle: {
    width: 100,
  },
});
